<template>
  <div id="mail-app">
    <div class="vs-row">
      <vs-col class="p-0" vs-xs="12" vs-sm="4" vs-lg="2" id="sidebar-div">
        <div class="con-vs-card cardx h-full mb-0">
          <header class="vs-card--header flex">
            <vs-button color="primary" class="whitespace-no-wrap w-full"
              ><i class="icon-plus align-middle text-white"></i> Compose
              Email</vs-button
            >
          </header>
          <div class="vs-card--content p-0">
            <ul class="nav flex-column mail-menu">
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: maillist == '' }]"
                  @click="activemails('')"
                  data-todotype="mail-item"
                >
                  <i class="icon-envelope pr-2"></i> Inbox
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: maillist == 'sent' }]"
                  @click="activemails('sent')"
                  data-todotype="starred"
                >
                  <i class="icon-paper-plane pr-2"></i> Send Email
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: maillist == 'draft' }]"
                  @click="activemails('draft')"
                  data-todotype="important"
                >
                  <i class="icon-pencil pr-2"></i> Draft
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: maillist == 'archive' }]"
                  @click="activemails('archive')"
                  data-todotype="completed"
                >
                  <i class="icon-folder-alt pr-2"></i> Archive
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  href="#"
                  :class="[{ active: maillist == 'trash' }]"
                  @click="activemails('trash')"
                  data-todotype="trashed"
                >
                  <i class="icon-trash pr-2"></i> Trash
                </a>
              </li>
            </ul>
            <div class="font-weight-bold px-3 mt-5"><b>Labels</b></div>
            <vs-divider />
            <ul class="nav flex-column mail-menu mt-0">
              <li class="nav-item px-3">
                <a
                  class="nav-link text-primary"
                  data-label="business-mail"
                  href="#"
                   @click="labelmails('business')"
                >
                  <i class="icon-pin"></i> Business
                </a>
              </li>
              <li class="nav-item px-3">
                <a
                  class="nav-link text-danger"
                  data-label="private-mail"
                  href="#"
                   @click="labelmails('private')"
                >
                  <i class="icon-pin"></i> Private
                </a>
              </li>
              <li class="nav-item px-3">
                <a
                  class="nav-link text-warning"
                  data-label="social-mail"
                  href="#"
                   @click="labelmails('social')"
                >
                  <i class="icon-pin"></i> Social
                </a>
              </li>
              <li class="nav-item px-3">
                <a
                  class="nav-link text-success"
                  data-label="personal-mail"
                  href="#"
                   @click="labelmails('personal')"
                >
                  <i class="icon-pin"></i> Personal
                </a>
              </li>
              <li class="nav-item px-3">
                <a class="nav-link text-info" data-label="work-mail" href="#"  @click="labelmails('work')">
                  <i class="icon-pin"></i> Work
                </a>
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col class="p-0" vs-sm="8" vs-xs="12" vs-lg="10">
        <div class="con-vs-card cardx mb-0 h-full rounded-none border-l-0">
          <div class="vs-card--content h-full p-0">
            <div class="todo-window p-0">
              <div class="flex items-center todo-search">
                <vs-input
                  size="large"
                  placeholder="Search..."
                  class="border-0 w-full"
                />
              </div>
              <div class="flex items-center todo-search p-4">
                <vs-checkbox class="w-8 m-0 vs-checkbox-medium" /> All

                <div class="ml-auto text-right w-1/2">
                  <vs-dropdown>
                    <a class="a-icon" href="#">
                      <i class="icon-bell"></i>
                    </a>
                    <vs-dropdown-menu class="whitespace-nowrap">
                      <vs-dropdown-item>
                        <span class="dot bg-primary"></span> Business
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <span class="dot bg-danger"></span> Private
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <span class="dot bg-warning"></span> Social
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <span class="dot bg-success"></span> Personal
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <span class="dot bg-info"></span> Work
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <a href="#" class="bulk-star mx-2"
                    ><i class="icon-star"></i
                  ></a>
                  <vs-dropdown>
                    <a class="a-icon" href="#">
                      <i class="icon-options-vertical font-15"></i>
                    </a>

                    <vs-dropdown-menu>
                      <vs-dropdown-item>
                        <i class="icon-book-open"></i> Mark as Read
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <i class="icon-notebook"></i> Mark as unread
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <i class="icon-trash"></i> Delete
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <VuePerfectScrollbar
                ref="chatwindow"
                class="scroll-area-todo-window"
                :settings="settings"
                @ps-scroll-y="scrollHandle"
              >
                <ul id="component-todo-log" v-if="mails" ref="chatLog">
                  <li class="py-3 px-2 mail-item inbox"  
                   v-for="(mail, index) in filterlist"
                   :class="[                      
                      { 'starred': mail.starred },
                      { 'important': mail.important },
                      { 'trash': mail.trash },
                      { 'font-bold': !mail.read },
                    ]"
                    :key="index">
                    <div class="flex align-self-center align-middle">
                       <vs-checkbox                     
                      class="w-8 m-0 vs-checkbox-medium"
                      @click.stop
                    />
                      <div class="mail-content flex w-full">
                        <span class="mail-type-icon">
                          <i class="icon-star mr-1"></i>
                          <i class="icon-exclamation mr-2"></i>
                        </span>
                        <span class="mail-user"> {{ mail.author }}</span>
                        <p class="mail-subject"> {{ mail.subject }}</p>
                        <div class="flex ml-auto">
                           <div class="pill-link" v-if="mail.attachment"> <i class="icon-link mr-3"></i> </div>
                          <div class="ml-md-auto mr-3 dot bg-primary"></div>
                          <p class="ml-auto mail-date mb-0">
                             {{ mail.time }}
                          </p>
                          <vs-dropdown>
                            <a class="a-icon" href="#">
                              <i class="icon-options-vertical font-15 ml-3"></i>
                            </a>

                            <vs-dropdown-menu>
                              <vs-dropdown-item>
                                <i class="icon-book-open"></i> Mark as Read
                              </vs-dropdown-item>
                              <vs-dropdown-item>
                                <i class="icon-notebook"></i> Mark as unread
                              </vs-dropdown-item>
                              <vs-dropdown-item>
                                <i class="icon-trash"></i> Delete
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                    </div>
                  </li>
                  
                </ul>
              </VuePerfectScrollbar>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "app",
  components: {
    VuePerfectScrollbar,
  },
  data: function () {
    return {
      settings: {
        maxScrollbarLength: 60,
      },
      maillist: "",
      filterlist: [],
      mails: [
        {
          subject: "Aenean ligula porttitor consequat vitae eleifend enim.",
          author:"Nathan S. Johnson",
          time: "June 15 at 07:10am",
          read: false,
          starred: true,
          important: true,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false,
          attachment: true,
          label: "business"
        },
         {
          subject: "Do You Know Iko Uwais, Justin Beiber on twitter?",
          author:"Roger L. Arteaga",
          time: "June 8 at 07:10am",
          read: true,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false,
          attachment: false,
          label: "private"
        },
         {
          subject: "Meeting Reminder Ut enim ad minim veniam, quis nostrud exercitation...",
          author:"Robert B. Peterson",
          time: "June 7 at 17:10am",
          read: false,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "social"
        },
         {
          subject: "Hi, John how are u today?",
          author:"Dorothy J. Robinson",
          time: "June 6 at 08:15am",
          read: false,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "personal"
        },
         {
          subject: "Follow more blogs and have more fun",
          author:"Marcus N. Shields",
          time: "May 16 at 07:33am",
          read: true,
          starred: false,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "work"
        },
         {
          subject: "We're transferring money from PayPal to your bank",
          author:"Beth M. Hargrove",
          time: "May 14 at 09:23am",
          read: true,
          starred: false,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "business"
        },
         {
          subject: "Aenean ligula porttitor consequat vitae eleifend enim.",
          author:"Nathan S. Johnson",
          time: "May 12 at 09:23am",
          read: true,
          starred: false,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "business"
        },
        {
          subject: "Aenean ligula porttitor consequat vitae eleifend enim.",
          author:"Nathan S. Johnson",
          time: "June 15 at 07:10am",
          read: false,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: false,
          attachment: true,
          label: "business"
        },
         {
          subject: "Do You Know Iko Uwais, Justin Beiber on twitter?",
          author:"Roger L. Arteaga",
          time: "June 8 at 07:10am",
          read: true,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: false,
          trash: true,
          attachment: false,
          label: "business"
        },
         {
          subject: "Meeting Reminder Ut enim ad minim veniam, quis nostrud exercitation...",
          author:"Robert B. Peterson",
          time: "June 7 at 17:10am",
          read: false,
          starred: true,
          important: false,
          sent: false,
          draft: false,
          inbox: true,
          archive: true,
          trash: false, 
          attachment: true,
          label: "business"
        },
         {
          subject: "We're transferring money from PayPal to your bank",
          author:"Beth M. Hargrove",
          time: "May 14 at 09:23am",
          read: true,
          starred: false,
          important: false,
          sent: false,
          draft: true,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "business"
        },
         {
          subject: "Aenean ligula porttitor consequat vitae eleifend enim.",
          author:"Nathan S. Johnson",
          time: "May 12 at 09:23am",
          read: true,
          starred: false,
          important: false,
          sent: true,
          draft: false,
          inbox: true,
          archive: false,
          trash: false, 
          attachment: true,
          label: "business"
        },
      ],
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  mounted() {
    this.filterlist = this.mails;
  },
  watch: {},
  created() {},
  methods: {
    scrollHandle(evt) {
      console.log(evt);
    },
    activemails(type) {
      this.maillist = type;
      if (type == "") {
        this.filterlist = this.mails;
      }
      if (type == "starred") {
        this.filterlist = this.mails.filter(function (item) {
          return item.starred;
        });
      }
      if (type == "important") {
        this.filterlist = this.mails.filter(function (item) {
          return item.important;
        });
      }
      if (type == "sent") {
        this.filterlist = this.mails.filter(function (item) {
          return item.sent;
        });
      }   
      if (type == "draft") {
        this.filterlist = this.mails.filter(function (item) {
          return item.draft;
        });
      }
       if (type == "archive") {
        this.filterlist = this.mails.filter(function (item) {
          return item.archive;
        });
      }
         if (type == "trash") {
        this.filterlist = this.mails.filter(function (item) {
          return item.trash;
        });
      }
    },
    labelmails(type) {
     
     
        this.filterlist = this.mails.filter(function (item) {
          return item.label==type;
        });
     
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/apps/mail.scss";
</style>